export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        console.group('%c[Vue Error Handler]', 'color: red; font-weight: bold;')
        console.error('Error:', error)
        console.error('Info:', info)
        console.error('Component:', instance)
        console.groupEnd()

        // You could also send this to Sentry/LogRocket here
    }

    nuxtApp.hook('app:error', (error) => {
        console.group('%c[Nuxt Error Handler]', 'color: orange; font-weight: bold;')
        console.error('Error:', error)
        console.groupEnd()
    })
})
